export const ElementsConfig = {
    fnameTextConfig: {
        type: 'textBox',
        value: '',
        name: 'forename',
        label: 'First name',
        readonly: false,
        maxlength: 18,
        controlName: 'forename',
        borderRequired: false,
        required: true,
        placeHolder: 'Please enter',
        errorMessage: 'Please enter a first name',
        errorMessageInvalid: 'Please enter a valid first name',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    lnameTextConfig: {
        type: 'textBox',
        value: '',
        name: 'surname',
        label: 'Surname',
        readonly: false,
        maxlength: 30,
        controlName: 'surname',
        borderRequired: false,
        required: true,
        placeHolder: 'Please enter',
        errorMessage: 'Please enter a surname',
        errorMessageInvalid: 'Please enter a valid surname',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    middleNameTextConfig: {
        type: 'textBox',
        value: '',
        name: 'middleName',
        label: 'Middle name',
        readonly: false,
        maxlength: 18,
        controlName: 'middleName',
        borderRequired: false,
        required: false,
        placeHolder: 'Please enter',
        errorMessage: 'Please enter a middle name',
        errorMessageInvalid: 'Please enter a valid middle name',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    thirdNameTextConfig: {
        type: 'textBox',
        value: '',
        name: 'thirdName',
        label: 'Third name',
        readonly: false,
        maxlength: 18,
        controlName: 'thirdName',
        borderRequired: false,
        required: false,
        placeHolder: 'Please enter',
        errorMessage: 'Please enter a third name',
        errorMessageInvalid: 'Please enter a valid third name',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    emailTextConfig: {
        type: 'textBox',
        value: '',
        name: 'emailAddress',
        label: 'Email address',
        content: 'We\'ll use this to send you a registration link, which you can use to retrieve your quotes and apply online.',
        readonly: false,
        controlName: 'emailAddress',
        borderRequired: false,
        required: true,
        placeHolder: 'Please enter',
        errorMessage: 'Please enter an e-mail address',
        invalidErrorMessage: 'Please enter a valid e-mail address',
        

        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    confirmEmailTextConfig: {
        type: 'textBox',
        value: '',
        name: 'confirmEmailAddress',
        label: 'Confirm email address',
        readonly: false,
        controlName: 'confirmEmailAddress',
        borderRequired: false,
        required: true,
        placeHolder: 'Please enter',
        errorMessage: 'Please enter a confirmation e-mail address',
        invalidErrorMessage: 'Please re-enter your confirmation e-mail address as it does not match',
        misMatchErrorMessage: 'Please re-enter your confirmation e-mail address as it does not match',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    mobilePhoneConfig: {
        type: 'textBox',
        value: '',
        name: 'mobilePhone',
        label: 'Mobile phone',
        readonly: false,
        controlName: 'mobilePhone',
        borderRequired: false,
        required: false,
        placeHolder: 'Please enter',
        errorMessage: 'Please enter a valid mobile phone number',
        invalidErrorMessage: 'Please use only numbers',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    mobileRegistrationPhoneConfig: {
        type: 'textBox',
        value: '',
        name: 'mobilePhone',
        label: 'Phone number', 
        readonly: false,
        controlName: 'mobilePhone',
        borderRequired: false,
        maxlength: 24,
        required: false,
        placeHolder: 'Please enter',
        errorMessage: 'Please enter a valid phone number',
        invalidErrorMessage: 'Please use numbers. If you using an international format, use + and the dial-in code at the beginning.',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    homePhoneConfig: {
        type: 'textBox',
        value: '',
        name: 'homePhone',
        label: 'Home phone (optional)',
        readonly: false,
        controlName: 'homePhone',
        borderRequired: false,
        required: false,
        placeHolder: 'Please enter',
        errorMessage: 'Please enter a valid home phone number',
        invalidErrorMessage: 'Please use only numbers',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    homeRegistrationPhoneConfig: {
        type: 'textBox',
        value: '',
        name: 'homePhone',
        label: 'Home phone (optional)',
        readonly: false,
        controlName: 'homePhone',
        borderRequired: false,
        maxlength: 24,
        required: false,
        placeHolder: 'Please enter',
        errorMessage: 'Please enter a valid home phone number',
        invalidErrorMessage: 'Please use numbers. If you using an international format, use + and the dial-in code at the beginning.',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    addressLine1Config: {
        type: 'textBox',
        value: '',
        name: 'addressline1',
        label: 'Address line 1',
        readonly: false,
        maxlength:'35',
        controlName: 'addressline1',
        borderRequired: false,
        required: true,
        placeHolder: 'Please enter',
       

        errorMessage: 'Please enter an address line 1 value',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    addressLine2Config: {
        type: 'textBox',
        value: '',
        name: 'addressline2',
        label: 'Address line 2',
        readonly: false,
        controlName: 'addressline2',
		maxlength:'35',
        borderRequired: false,
        required: false,
        placeHolder: 'Please enter',
       

        errorMessage: 'Please enter an address line 2 value',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    addressLine3Config: {
        type: 'textBox',
        value: '',
        name: 'addressline3',
        label: 'Address line 3',
		readonly: false,
        controlName: 'addressline3',
		maxlength:'35',
        borderRequired: false,
        required: false,
        placeHolder: 'Please enter',
       

       
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    addressLine4Config: {
        type: 'textBox',
        value: '',
        name: 'addressline4',
        label: 'Address line 4',
		readonly: false,
        controlName: 'addressline4',
		maxlength:'35',
        borderRequired: false,
        required: false,
        placeHolder: 'Please enter',
       

       
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    personalDetailDOBInformation: {
        label: '',
        // tslint:disable-next-line:max-line-length
        content: 'THIS TEXT HAS BEEN MIGRATED TO THE CMS. IF YOU SEE THIS CONTACT DCJ SUPPORT TEAMS. For us to give you a valid quote, you\'ll need to be in the right age bracket to take an annuity within the next 35 days. Our minimum age is 54 years and 9 months and our maximum is 120 years. If you are in a special situation, please call us.',
        disabledInfoIconTextVisibility: false
    },
    postCodeInformationConfig: {
        label: '',
        // tslint:disable-next-line:max-line-length
        content: 'THIS TEXT HAS BEEN MIGRATED TO THE CMS. IF YOU SEE THIS CONTACT DCJ SUPPORT TEAMS. This helps us check whether we can give you a quote. If you haven\'t got a UK address please set this field to No',
        disabledInfoIconTextVisibility: false
    },
    postCodetextConfig: {
        label: '',
        // tslint:disable-next-line:max-line-length
        content: 'Postcode of customer\'s current permanent UK residential address',
        disabledInfoIconTextVisibility: false
    },

    firstNameToolTipInfoConfig: {
        label: '',
        // tslint:disable-next-line:max-line-length
        content: 'Your first name, middle name and surname should not contain any numbers or punctuation apart from ` and -',
        disabledInfoIconTextVisibility: false
    },
    //added for RA-8770 - New tool-tip against address field
    addressToolTipInfoCodeConfig: {
        label: '',
        // tslint:disable-next-line:max-line-length
        content: 'Address information is needed to facilitate and analyse your quote and/or application, as described in our privacy notice.',
        disabledInfoIconTextVisibility: false
    },
    guidanceAdviceConfig1: {
        type: 'dropdown',
        options: [
            {
                code: 'AA',
                value: 'Yes',
              },
              {
                code: 'AB',
                value: 'No – I will book my own appointment',
              },
              {
                code: 'AC',
                value: 'No – I have already received pensions guidance',
              },
              {
                code: 'AD',
                value: 'No – I have received regulated advice',
              },
              {
                code: 'AE',
                value: 'No – I want to proceed without guidance or advice',
              }
        ],
        options1: [
            {
                code: 'AA',
                value: 'Yes',
              },
              {
                code: 'AE',
                value: 'No – I want to proceed without guidance or advice',
              }
        ],
        defaultValue: null,
        name: 'bookPensionWiseAppointmentQuestion',
        label: 'Would you like us to book a Pension Wise appointment for you?',
        errorMessage: 'Please select a option',
        readonly: false,
        controlName: 'bookPensionWiseAppointmentQuestion',
        borderRequired: false,
        required: true,
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    guidanceAdviceConfig2: {
        type: 'dropdown',
        options: [
            {
                code: 'AA',
                value: 'Yes',
              },
              {
                code: 'AC',
                value: 'No – I did not attend my appointment',
              },
              {
                code: 'AD',
                value: 'No – I have received regulated advice',
              },
              {
                code: 'AE',
                value: 'No – I want to proceed without guidance or advice',
              }
        ],
        options2: [
            {
                code: 'AA',
                value: 'Yes',
              },
              {
                code: 'AD',
                value: 'No – I have received regulated advice',
              },
              {
                code: 'AE',
                value: 'No – I want to proceed without guidance or advice',
              }
        ],
        defaultValue: null,
        name: 'attendedPensionWiseAppointmentQuestion',
        label: 'Have you attended your appointment and received the guidance?',
        errorMessage: 'Please select a option',
        readonly: false,
        controlName: 'bookPensionWiseAppointmentQuestion',
        borderRequired: false,
        required: true,
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    genderConfig: {
        type: 'dropdown',
        options: [
            { value: 'Male', code: 'M' },
            { value: 'Female', code: 'F' }
        ],
        defaultValue: null,
        name: 'gender',
        label: 'Gender',
        errorMessage: 'Please select a gender',
        readonly: false,
        controlName: 'gender',
        borderRequired: false,
        required: true,
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    fundProviderConfig: {
        type: 'dropdown',
        options: [
            { value: 'Aegon', code: 'H', controlName: 'aegon' },
            { value: 'Legal & General', code: 'I', controlName: 'internal' },
            { value: 'Prudential', code: 'K', controlName: 'prudential' },
            { value: 'PensionBee', code: 'L', controlName: 'pensionBee'},
            { value: 'Aon', code: 'M', controlName: 'aon'},
            { value: 'ReAssure', code: 'J', controlName: 'reAssure' }, 
            { value: 'Sun Life Financial of Canada', code: 'F', controlName: 'sunLife' },
            { value: 'Phoenix Life', code: 'O', controlName: 'phoenixLife' },
            { value: 'HSBC', code:'R', controlName:'hsbc' }, 
            { value: 'More than one of the above', code: 'D', controlName: 'many' },
            { value: 'None of the above', code: 'B', controlName: 'external' }
        ],
        defaultValue: null,
        name: 'fundProvider',
        label: 'THIS TEXT HAS BEEN MIGRATED TO THE CMS. IF YOU SEE THIS CONTACT DCJ SUPPORT TEAMS. Which pension provider referred you to us for this quote? ',
        // tslint:disable-next-line:max-line-length
        prudentialInvalid: 'THIS TEXT HAS BEEN MIGRATED TO THE CMS. IF YOU SEE THIS CONTACT DCJ SUPPORT TEAMS. We are unable to give you a quote online but we can over the phone. Please call customer services on 0800 048 2446 and quote your reference number which you can find at the top of the screen.',
        externalInvalid: 'THIS TEXT HAS BEEN MIGRATED TO THE CMS. IF YOU SEE THIS CONTACT DCJ SUPPORT TEAMS. We are unable to give you a quote as you do not live in the UK.',
        // tslint:disable-next-line:max-line-length
        manyInvalid: 'THIS TEXT HAS BEEN MIGRATED TO THE CMS. IF YOU SEE THIS CONTACT DCJ SUPPORT TEAMS. As you have been introduced by more than one of our partners, we need to give you individual quotes for each of your pension funds to ensure you get the best deal. You can do these online by selecting each partner individually or you can call customer services on 0800 048 2446 and quote your reference number which you can find at the top of the screen.',
        sourceInvalid: 'THIS TEXT HAS BEEN MIGRATED TO THE CMS. IF YOU SEE THIS CONTACT DCJ SUPPORT TEAMS. As you have been introduced by more than one of our partners, we need to give you individual quotes for each of your pension funds to ensure you get the best deal. You can do these online by selecting each partner individually or you can call customer services on 0800 048 2446 and quote your reference number which you can find at the top of the screen.',
        errorMessage: 'Please make a selection',
        readonly: false,
        controlName: 'fundProvider',
        borderRequired: false,
        required: true,
        // tslint:disable-next-line:max-line-length
        content: 'THIS TEXT HAS BEEN MIGRATED TO THE CMS. IF YOU SEE THIS CONTACT DCJ SUPPORT TEAMS. We need you to select which pension provider contacted you to refer you here to get a quote. This so we can make sure our quote accurately matches your circumstances. If you weren’t contacted or your provider isn’t shown please select other.',
    },
    maritalStatusConfig: {
        type: 'dropdown',
        options: [
            { value: 'Single', code: 'S' },
            { value: 'Married', code: 'M' },
            { value: 'Registered civil partnership', code: 'CP' },
            { value: 'Cohabiting', code: 'CH' },
            { value: 'Divorced', code: 'D' },
            { value: 'Separated', code: 'SE' },
            { value: 'Widowed', code: 'W' }
        ],
        defaultValue: null,
        name: 'maritalStatus',
        label: 'Marital status',
        errorMessage: 'Please select a marital status',
        readonly: false,
        controlName: 'maritalStatus',
        borderRequired: false,
        required: true,
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },

    titleConfig: {
        type: 'dropdown',
        options: [
            {  value: 'Mr', code: 'Mr' },
            { value: 'Miss',  code: 'Miss' },
            {  value: 'Mrs', code: 'Mrs' },
            {  value: 'Ms', code: 'Ms' },
            {  value: 'Mx', code: 'Mx' },
            {  value: 'Doctor', code: 'Doctor' },
            {  value: 'Other', code: 'Other' }
        ],
        defaultValue: null,
        name: 'userTitle',
        label: 'Title',
        errorMessage: 'Please select a title',
        readonly: false,
        controlName: 'userTitle',
        borderRequired: false,
        required: true,
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    radioButtonIsUKAddressConfig: {
        // tslint:disable-next-line:max-line-length
        questionStatement: 'Are you a UK resident?',
        questionType: 'Static',
        isSafetyQuestion: false,
        questionOptions: [
            {
                label: 'Yes',
                code: 'Y'
            },
            {
                label: 'No',
                code: 'N'
            }
        ],
        validationMsg: 'Please make a selection',
        disabled: false
    },
    postCodeConfig: {
        type: 'textBox',
        defaultValue: '',
        name: 'postcode',
        labelText: 'Postcode',
        controlName: 'postcode',
        readonly: false,
        errorMessage: 'Please enter a postcode',
        errorMessageInvalid: 'Please enter a valid UK postcode',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    dobConfig: {
        type: 'textBox',
        value: '',
        name: 'dateOfBirth',
        label: 'Date of birth',
        readonly: false,
        controlName: 'dateOfBirth',
        controlWidth: 150,
        borderRequired: false,
        required: true,
        placeHolder: 'DD / MM / YYYY',
        errorMessage: 'Please enter a date of birth',
        errorMessageInvalidDate: 'Please enter a valid date',
        errorMessageInvalidFormat: 'Please enter a date in format DD/MM/YYYY',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    relationshipConfig: {
        type: 'dropdown',
        options: [
            { value: 'Spouse', code: 'S' },
            { value: 'Registered civil partner', code: 'R' },
            { value: 'Financial dependant', code: 'F' }
        ],
        defaultValue: null,
        name: 'relationship',
        label: 'Relationship to you',
        errorMessage: 'THIS TEXT HAS BEEN MIGRATED TO THE CMS. IF YOU SEE THIS CONTACT DCJ SUPPORT TEAMS. Please select a relationship to you',
        readonly: false,
        controlName: 'relationship',
        borderRequired: false,
        required: true,
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    buttonConfig: {
        type: 'button',
        values: '',
        name: 'next',
        label: 'Next',
        readonly: false,
        controlName: 'next',
        borderRequired: false,
        required: true,
        classType: 'btn-cta',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    regsiterbuttonConfig: {
        type: 'button',
        values: '',
        name: 'next',
        label: 'Next',
        readonly: false,
        controlName: 'next',
        borderRequired: false,
        required: true,
        classType: 'btn-cta',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    dependantDetailDob: {
        type: 'textBox',
        value: '',
        name: 'dateOfBirth',
        label: 'Date of birth',
        readonly: false,
        controlName: 'dateOfBirth',
        controlWidth: 150,
        borderRequired: false,
        required: true,
        placeHolder: 'DD / MM / YYYY',
        errorMessage: 'THIS TEXT HAS BEEN MIGRATED TO THE CMS. IF YOU SEE THIS CONTACT DCJ SUPPORT TEAMS. Please enter a date of birth',
        errorMessageInvalidDate: 'THIS TEXT HAS BEEN MIGRATED TO THE CMS. IF YOU SEE THIS CONTACT DCJ SUPPORT TEAMS. Please enter a valid date',
        errorMessageInvalidFormat: 'Please enter a date in format DD/MM/YYYY',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    depandantDetailGenderConfig: {
        type: 'dropdown',
        options: [
            { value: 'Male', code: 'M' },
            { value: 'Female', code: 'F' }
        ],
        defaultValue: null,
        name: 'gender',
        label: 'Gender',
        errorMessage: 'THIS TEXT HAS BEEN MIGRATED TO THE CMS. IF YOU SEE THIS CONTACT DCJ SUPPORT TEAMS. Please select a gender',
        readonly: false,
        controlName: 'gender',
        borderRequired: false,
        required: true,
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    sourcesListCvt: [
        { value: 'Legal & General', code: 'Int.', controlName: 'internal',fundProvider: 'Int.' },
        { value: 'Aegon', code: 'CDF', controlName: 'aegon', productCodeValidationRule: /^[0-0]{2}[t]?$/i,fundProvider: 'H' },
        { value: 'PensionBee', code:'CDF', controlName:'pensionBee',fundProvider: 'L' },
        { value: 'Aon', code:'CDF', controlName:'aon',fundProvider: 'M' },
        { value: 'Sun Life Financial of Canada', code: 'CDF', controlName: 'sunLife', productCodeValidationRule: /^[0]$/i,fundProvider: 'F' },
        { value: 'Phoenix Life', code: 'CDF', controlName: 'phoenixLife', productCodeValidationRule: /^[0]$/i, fundProvider: 'O' },
        { value: 'ReAssure', code: 'CDF', controlName: 'reAssure',fundProvider: 'J' },
        { value: 'HSBC', code:'CDF', controlName:'hsbc',fundProvider: 'R' }, 
        { value: 'Other', code: 'Ext', controlName: 'external',fundProvider: 'Ext' }
    ],
    fundAttributes: [
        'fundValue', 'transferType', 'productCode'
    ],
    fundValueConfig: {
        type: 'currency',
        value: '',
        name: 'fundValue',
        readonly: false,
        controlName: 'fundValue',
        required: true,
        placeHolder: '',
        errorMessage: '',
        minValue: '0.00',
        maxValue: '99999999.99',
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'If you choose yearly income then we will calculate your maturity value based on the money that is left over. If you choose maturity value, then we will calculate this and the remaining money will be used to calculate your income.',
            disabledInfoIconTextVisibility: false
        },
        infoIconFlag: false
    },
    productCodeConfig: {
        type: 'textBox',
        value: '',
        name: 'productCode',
        label: 'Product Code',
        readonly: false,
        controlName: 'productCode',
        borderRequired: false,
        required: false,
        validationMsg: 'Please enter an amount',
        placeHolder: 'Please enter',
        addAnothercode: 'Add another code',
        errorProductCode: 'Please enter the product code',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        },
        validationRule: /^[0-9]{2}[a-z]$/i
    },
    dependantDetailTitleInformation: {
        label: '',
        // tslint:disable-next-line:max-line-length
        content: 'THIS TEXT HAS BEEN MIGRATED TO THE CMS. IF YOU SEE THIS CONTACT DCJ SUPPORT TEAMS. Our Pension Annuity lets you nominate your surviving partner for an income for life, from your pension savings. This will be your spouse, civil partner or another financially-dependent partner. If this excludes someone you need to take care of in the event of your death, you may choose a different kind of protection for them, in a few moments.',
        disabledInfoIconTextVisibility: false
    },
    productChoice: {
        products: [
            {
                productName: 'Pension Annuity',
                productCode: 'C',
                controlName: 'chkPensionAnnuity',
                selected: false,
                imageName: 'pensionAnnuity-logo.png'
            },
            {
                productName: 'Fixed Term Retirement Plan',
                productCode: 'H',
                controlName: 'chkFixedTerm',
                selected: false,
                imageName: 'fixedTermRetiremen-logo.png'
            },
            {
                productName: 'Cash-Out Retirement Plan',
                productCode: 'G',
                controlName: 'chkCashOut',
                selected: false,
                imageName: 'fixedTermRetiremen-logo.png'
            }
        ]
    },
    QuoteAffectingValues: {
        personalDetail: [
            'gender',
            'dateOfBirth',
            'maritalStatus',
            'postcode',
            'ukaddressIndicator'
        ],
        dependantDetail: [
            'gender',
            'dateOfBirth',
            'relationship'
        ]
    },
    radioButtonDependantConfig: {
        // tslint:disable-next-line:max-line-length
        questionStatement: 'THIS TEXT HAS BEEN MIGRATED TO THE CMS. IF YOU SEE THIS CONTACT DCJ SUPPORT TEAMS. Would you like us to pay an income to a qualifying dependent partner when you die?',
        questionType: 'Static',
        isSafetyQuestion: false,
        questionOptions: [
            {
                label: 'Yes',
                code: 'Y'
            },
            {
                label: 'No',
                code: 'N'
            }
        ],
        infoIconFlag: true,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'Consider if the plan you choose will provide the right benefits for your loved ones in the event of your death.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        disabled: false
    },
    healthAndLifestyleConfig: { 
        type: 'textBox',
        value: '',
        name: 'healthAndLifestyle',
        label: 'Integer',
        readonly: false,
        controlName: 'healthAndLifestyle',
        borderRequired: false,
        required: true,
        placeHolder: 'Please enter',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        },
        tooltipInfo: {
            label: '',
            content: '',
            disabledInfoIconTextVisibility: false
        },
        validationRule: /^[0-9]{2}[a-z]$/i
    },
    dealPartnerInformation: {
        label: '',
        // tslint:disable-next-line:max-line-length
        content: 'THIS TEXT HAS BEEN MIGRATED TO THE CMS. IF YOU SEE THIS CONTACT DCJ SUPPORT TEAMS. We need you to select which pension provider referred you to us for a quote. This is so we can make sure our quote accurately matches your circumstances. If you weren’t referred please select \'None of the above\'. ',
        disabledInfoIconTextVisibility: false
    },
    diabetesConfig: {
        type: 'dropdown',
        options: [
            { value: '', code: '' },
            { value: '', code: '' }
        ],
        defaultValue: null,
        name: 'diabetes',
        label: 'Is your Diabetes?',
        errorMessage: '- Please select -',
        readonly: false,
        controlName: 'diabetes',
        borderRequired: false,
        required: true,
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    medicalConditions: {
        list: [
            {
                mcName: 'High Blood Pressure',
                mcCode: 'HBP',
                controlName: 'chkHighBloodPressure',
                selected: false
            },
            {
                mcName: 'High Cholesterol',
                mcCode: 'HC',
                controlName: 'chkHighCholesterol',
                selected: false
            },
            {
                mcName: 'Diabetes',
                mcCode: 'D',
                controlName: 'chkDiabetes',
                selected: false
            },
            {
                mcName: 'Respiratory Disease',
                mcCode: 'RD',
                controlName: 'chkRespiratoryDisease',
                selected: false
            },
            {
                mcName: 'Heart Disease',
                mcCode: 'HD',
                controlName: 'chkHeartDisease',
                selected: false
            },
            {
                mcName: 'Cancer',
                mcCode: 'C',
                controlName: 'chkCancer',
                selected: false
            },
            {
                mcName: 'Stroke',
                mcCode: 'H',
                controlName: 'chkStroke',
                selected: false
            },
            {
                mcName: 'Neurological Disease',
                mcCode: 'ND',
                controlName: 'chkNeurologicalDisease',
                selected: false
            },
            {
                mcName: 'Other',
                mcCode: 'O',
                controlName: 'chkOther',
                selected: false
            }
        ]
    },
    taxfreeValueConfig: {
        type: 'currency',
        value: '',
        name: 'fundValue',
        readonly: false,
        controlName: 'fundValue',
        required: true,
        placeHolder: '',
        errorMessage: 'Please make a selection',
        customErrorMessage1: 'If you don’t require a maturity value, please select Cashout Plan',
        invalidTaxfreeMessage: 'Selected tax-free cash exceeds 25% of [dealpartner] policy fund',
        minValue: '0.00',
        maxValue: '99999999.99',
        infoIconData: {
            // tslint:disable-next-line:max-line-length
            content: 'If you choose yearly income then we will calculate your maturity value based on the money that is left over. If you choose maturity value, then we will calculate this and the remaining money will be used to calculate your income.',
            disabledInfoIconTextVisibility: false
        },
        infoIconFlag: true,
        title: true,
        titleValue: '0'
    }
};
